
import { ErrorType, QueryError } from "../types";

const fetchMsal = async (
    input: RequestInfo | URL, init?: RequestInit
) => {
  try {
    const res = await fetch(input, init);

    const handledStatus = [400, 401, 403, 404];
    if (handledStatus.indexOf(res.status) > -1) {
      const contentType = res.headers.get("content-type") || "";

      let message: string = "";
      let errorCode: string | undefined = undefined;

      try {
        if (contentType.includes("application/json")) {
          const json = await res.json();
          if ("message" in json) message = json.message;
          if ("error" in json) errorCode = json.error;
        } else {
          message = await res.text();
        }
      } catch (error) {
        message = "";
      }

      if (res.status === 400) {
        throw new QueryError(ErrorType.BADREQUEST, message, errorCode);
      }
      if (res.status === 403) {
        throw new QueryError(ErrorType.FORBIDDEN, message, errorCode);
      }
      if (res.status === 401) {
        throw new QueryError(ErrorType.UNAUTHORIZED, message, errorCode);
      }
      if (res.status === 404) {
        throw new QueryError(ErrorType.NOT_FOUND, message, errorCode);
      }
    }

    return res;
  } catch (e) {
    throw e;
  }
};

export default fetchMsal;
